// extracted by mini-css-extract-plugin
export default {"component":"b2qh7Z","scrollNavigationButtonContainer":"c2qh7Z","scrollButton":"d2qh7Z","scrollButtonNext":"e2qh7Z","scrollButtonPrevious":"f2qh7Z"};